import { PoolLeagueApiClient } from '../base-client/pool-league-api-client';
import { Injectable } from '@angular/core';
import {
  CompetitionStatus,
  Division,
  DivisionWithMatches,
  EditLeagueResultResponse,
  Format,
  LEAGUE_CREATE,
  LEAGUE_DELETE_RESULT,
  LEAGUE_GET_DIVISION,
  LEAGUE_GET_DIVISIONS,
  LEAGUE_SAVE_RESULT,
  LEAGUE_UPDATE_PLAYOFF,
  LEAGUE_UPDATE,
  Playoff,
  RoundRobinCompetition,
  CreateLeaguePutBody,
  CreateLeaguePutResponse,
} from '@pool-league/shared-data-api';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LeagueApiClient extends PoolLeagueApiClient {
  createLeague(
    seasonId: string,
    format: Format,
    divisions: CreateLeaguePutBody,
  ): Observable<CreateLeaguePutResponse> {
    return this.buildRequest(LEAGUE_CREATE, {
      seasonId,
      format,
    }).put<CreateLeaguePutResponse>(divisions);
  }

  getDivisions(seasonId: string, format: Format) {
    return this.buildRequest(LEAGUE_GET_DIVISIONS, {
      seasonId,
      format,
    }).get<Division[]>();
  }

  getDivision(seasonId: string, format: Format, division: number) {
    return this.buildRequest(LEAGUE_GET_DIVISION, {
      seasonId,
      format,
      division: `${division}`,
    }).get<DivisionWithMatches>();
  }

  deleteResult(
    seasonId: string,
    format: Format,
    division: number,
    match: number,
  ) {
    return this.buildRequest(LEAGUE_DELETE_RESULT, {
      seasonId,
      format,
      division: `${division}`,
      match: `${match}`,
    }).delete<EditLeagueResultResponse>();
  }

  saveResult(
    seasonId: string,
    format: Format,
    division: number,
    match: number,
    winner: string,
    result: 'F' | number,
  ): Observable<EditLeagueResultResponse> {
    return this.buildRequest(LEAGUE_SAVE_RESULT, {
      seasonId,
      format,
      division: `${division}`,
      match: `${match}`,
    }).put({
      winner,
      result,
    });
  }

  setPlayoffParticipants(
    seasonId: string,
    format: Format,
    playoff: number,
    players: readonly [string, string],
  ) {
    return this.buildRequest(LEAGUE_UPDATE_PLAYOFF, {
      seasonId,
      format,
      playoff: `${playoff}`,
    }).patch<Playoff>({
      players,
    });
  }

  setPlayoffScore(
    seasonId: string,
    format: Format,
    playoff: number,
    score: [number, number],
  ) {
    return this.buildRequest(LEAGUE_UPDATE_PLAYOFF, {
      seasonId,
      format,
      playoff: `${playoff}`,
    }).patch<Playoff>({
      score,
    });
  }

  resetPlayoff(seasonId: string, format: Format, playoff: number) {
    return this.buildRequest(LEAGUE_UPDATE_PLAYOFF, {
      seasonId,
      format,
      playoff: `${playoff}`,
    }).patch<Playoff>({
      players: ['', ''],
      score: [0, 0],
    });
  }

  setStatus(
    seasonId: string,
    format: Format,
    status: CompetitionStatus,
  ): Observable<RoundRobinCompetition> {
    return this.buildRequest(LEAGUE_UPDATE, {
      seasonId,
      format,
    }).patch<RoundRobinCompetition>({ status });
  }
}
